var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('deviceBorrowItem',{staticClass:"giveBack",attrs:{"loaddingClass":"giveBack","rowKeyList":_vm.rowKeyList,"keyList":_vm.keyList,"queryType":4}})}
var staticRenderFns = []

export { render, staticRenderFns }